import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_REPORT_RCPA} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const RCPAReport = lazy(() =>
  import('../../../screens/RCPA-RCPAReport')
    .then(module => ({default: module.RCPAReport})));

const RCPA_RCPAReportNavigation = [
  {
    path: ROUTE_REPORT_RCPA,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <RCPAReport />
      </Suspense>
    ),
  },
];

export default RCPA_RCPAReportNavigation;
